export enum BlackjackBetDecision {
    DOUBLE = 'Double',
    SPLIT = 'Split',
}
